// extracted by mini-css-extract-plugin
module.exports = {"Nav":"nav_Nav__ScFhL","active":"nav_active__2UcI3"};